import { Component, OnDestroy, OnInit } from '@angular/core';
import { SiteConfig } from 'src/app/models/site.config.models';
import { BrandingService } from 'src/app/services/branding.service';
import { HttpService } from "src/app/services/http.service";
import { WebinarRecord } from '../referee/referee.models';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-check-cancelled',
    templateUrl: './check-cancelled.component.html',
    styleUrls: ['./check-cancelled.component.scss'],
    standalone: false
})
export class CheckCancelledPage implements OnInit, OnDestroy {
  public branding$: Observable<SiteConfig|null>;
  public webinarData: WebinarRecord[] = [];
  public subscription$: Subscription = new Subscription;

  constructor(
    brandingService: BrandingService,
    private httpService: HttpService
  ) {
    this.branding$ = brandingService.branding$;
  }

  ngOnInit(): void {
    this.subscription$.add(this.httpService.getWebinarsData().subscribe({
      next: result => {
        this.webinarData = result.webinarData;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
